import api from './api';

const URLS = {
  login: 'groupBookinglogin',
};

export const login = (loginRequest) => {
  return api.post(URLS.login, loginRequest);
};
